/* eslint react/require-default-props: off */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { Box } from '@leagueplatform/genesis-commons';
import { func, shape, string, number } from 'prop-types';
// eslint-disable-next-line no-restricted-imports
import { Transition, SwitchTransition } from 'react-transition-group';

export const TransitionTypes = Object.freeze({
  FADE: 'fade',
});

const { FADE } = TransitionTypes;

const getTransitionStyles = (type = FADE, duration = 350) =>
  ({
    [FADE]: {
      defaultStyles: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
        'will-change': 'opacity',
      },
      transitionStyles: {
        entering: { opacity: 0 },
        entered: { opacity: 1 },
        exiting: { opacity: 0 },
        exited: { opacity: 0 },
      },
    },
  }[type]);

const getViewWithProps = (viewObject) => {
  const component = { View: React.Fragment, props: {} };

  // If there is no view object return a fragment with no props
  if (!viewObject) return component;

  // If there is view, determine if it using the object syntax to declare a view with props
  component.View = viewObject?.view ?? viewObject;
  component.props = viewObject?.props ?? {};

  return component;
};

export const ViewTransitionController = ({
  handleActiveView,
  views,
  duration = 350,
  transitionType: type = FADE,
  ...rest
}) => {
  const nodeRef = React.useRef(null);
  const { defaultStyles, transitionStyles } = getTransitionStyles(
    type,
    duration,
  );
  const activeView = handleActiveView();
  const { View, props } = getViewWithProps(views?.[activeView]);
  return (
    <SwitchTransition>
      <Transition nodeRef={nodeRef} timeout={duration} key={activeView}>
        {(state) => (
          <Box
            ref={nodeRef}
            {...defaultStyles}
            {...transitionStyles[state]}
            {...rest}
          >
            <View {...props} />
          </Box>
        )}
      </Transition>
    </SwitchTransition>
  );
};

ViewTransitionController.propTypes = {
  transitionType: string,
  duration: number,
  handleActiveView: func.isRequired,
  views: shape({}).isRequired,
};
